import { Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";

export default function NotFoundPage() {
  return (
    <div className="bg-[#070d18] text-slate-100 min-h-[70vh] flex items-center justify-center py-20 px-4">
      <SEOHead
        title="Siden blev ikke fundet"
        description="Den efterspurgte side kunne ikke findes på KVC Express ApS."
      />

      <div className="max-w-lg w-full text-center space-y-6 bg-[#0b1426] p-8 sm:p-12 rounded-2xl border border-slate-800 shadow-2xl">
        <div className="w-16 h-16 rounded-full bg-[#0F766E]/20 border border-[#2DD4BF]/40 text-[#2DD4BF] flex items-center justify-center mx-auto text-2xl font-mono font-bold">
          404
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold text-white font-display">
          Siden blev ikke fundet
        </h1>

        <p className="text-slate-300 text-sm leading-relaxed">
          Den adresse, du har åbnet, findes ikke længere eller er blevet flyttet.
        </p>

        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-[#0F766E] hover:bg-[#115E59] text-white font-semibold text-xs uppercase tracking-wider transition shadow-lg shadow-[#0F766E]/30"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>
          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 border border-slate-700 text-slate-200 hover:text-white font-semibold text-xs uppercase tracking-wider transition"
          >
            <span>Kontakt</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
